<template>
  <div>
    <el-select
      size="mini"
      placeholder="Servicio al Cliente"
      v-model="Customer_filter"
      filterable
      clearable
      @change="handleFilter"
    >
      <el-option
        v-for="(item, index) in customerList"
        :key="index"
        :value="item.Code"
        :label="item.FullName"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: "ClientRabbeyCustomerServiceSelector",

  data() {
    return {
      Customer_filter: "",
      customerList: []
    };
  },

  async mounted() {
    await this.list_customerservices();
  },

  methods: {
    async list_customerservices() {
      await this.$http
        .get(
          `/api/customers/AllCustomerServices?companyCode=${this.currentCompany}`
        )
        .then((resp) => {
          this.customerList = resp.data.map((i) => {
            return {
              Code: i.Code,
              FullName: i.FullName
            };
          });
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    handleFilter(val) {
      this.$emit("CustomerServiceChanged", val);
    }
  }
};
</script>

<style scoped></style>
